import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import UserInfo from '@Components/Profile/UserInfo';

import { useIsLoggedIn } from '@Services/User';

import Layout from '@Templates/Layout';

import ProjectInfo from '@Components/Profile/ProjectInfo';
import SnackBar from '@Components/Common/SnackBar';

const Profile = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector(useIsLoggedIn);
  const snackBarRef = useRef(null);

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/login', { replace: true });
    }
  }, [isLoggedIn]);

  if (!isLoggedIn) {
    return null;
  }

  return (
    <Layout>
      <Container>
        <UserInfo />
        <ProjectInfo />
      </Container>
      <SnackBar ref={snackBarRef} />
    </Layout>
  );
};

const Container = styled.div`
  height: 100vh;
  padding-top: ${window.innerHeight * 0.2}px;
`;

export default Profile;
